import { render } from "./cardPotrait.vue?vue&type=template&id=79485964&scoped=true"
import script from "./cardPotrait.vue?vue&type=script&lang=js"
export * from "./cardPotrait.vue?vue&type=script&lang=js"

import "./cardPotrait.vue?vue&type=style&index=0&id=79485964&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79485964"]])

export default __exports__